import React from 'react';
import Create from '../../rest/Create';
import Form from '../components/Form';

const LogsCreate = props => (
  <Create {...props} resource="logs">
    <Form />
  </Create>
);

LogsCreate.propTypes = {};

export default LogsCreate;
